export { NavbarPromoSlot } from "./NavbarPromoSlot";
